<template>
  <div>
    <b-table class="mt-2" ref="table" hover head-variant="light"
             :items="jobHistory" :fields="fields" >
        <template v-slot:cell(content)="row">
          <b-img
            class="mr-1"
            v-if="row.item.content.thumbNail" rounded
            :src="row.item.content.thumbNail"
            :height="40" :width="40"
            :id="`popover-${row.item.jobId}${row.item.updated}`">
          </b-img>
          <b-popover placement="right"
            v-if="row.item.content.thumbNail"
            :target="`popover-${row.item.jobId}${row.item.updated}`"
            triggers="hover">
            <b-img fluid :src="row.item.content.preview">
            </b-img>
          </b-popover>
          {{ row.item.content.title }}
        </template>

        <template v-slot:cell(status)="row">
          <b class="text-success" v-if="isCompleted(row.item)">{{ $t('transfer.contentStatusReady') }}</b>
          <b class="text-danger" v-if="isError(row.item)">{{ $t('transfer.contentStatusError') }}</b>
          <b class="text-warning" v-if="isSyncing(row.item)">{{ $t('transfer.contentStatusSync') }}</b>
          <b class="text-primary" v-if="isQueued(row.item)">{{ $t('transfer.contentStatusQueued') }}</b>
        </template>
    </b-table>
  </div>
</template>

<script>
  export default {
    name: 'JobHistory',

    props: {
      jobHistory: {
        default: null
      },
      driver: {
        default: null
      }
    },

    data () {
      return {
        fields: [
          {
            key: 'content',
            label: this.$t('transfer.content'),
            thClass: 'asset-text-cell',
            tdClass: 'asset-text-cell align-middle'
          },
          {
            key: 'created',
            label: this.$t('transfer.created'),
            thClass: 'asset-text-cell',
            tdClass: 'asset-text-cell align-middle'
          },
          {
            key: 'updated',
            label: this.$t('transfer.updated'),
            thClass: 'asset-text-cell',
            tdClass: 'asset-text-cell align-middle'
          },
          {
            key: 'status',
            label: this.$t('transfer.syncStatus'),
            thClass: 'asset-text-cell',
            tdClass: 'asset-text-cell align-middle'
          }
        ]
      }
    },

    methods: {
      isQueued (job) {
        return this.driver.getStatusString(job.status) === 'STATUS_QUEUED'
      },

      isSyncing (job) {
        return this.driver.getStatusString(job.status) === 'STATUS_SYNCING'
      },

      isError (job) {
        return this.driver.getStatusString(job.status) === 'STATUS_ERROR'
      },

      isCompleted (job) {
        return this.driver.getStatusString(job.status) === 'STATUS_COMPLETED'
      }
    }
  }
</script>

<style scoped>

</style>
